import { AlarmRuleOperator, BacnetObjectType } from "@eisox/api/core-api";
import { z } from "@eisox/zod";

const alarmSchema = z.object({
  name: z.string().nonempty(),
  gatewayId: z.string().nonempty(),
  deviceId: z.number().int().min(0),
  objectType: z.enum(BacnetObjectType),
  objectInstance: z.number().int().min(0),
  isEnabled: z.boolean(),
  isNotificationEnabled: z.boolean(),
  rule: z.object({
    operator: z.enum(AlarmRuleOperator),
    value: z.number(),
  }),
});

type AlarmSchemaType = z.infer<typeof alarmSchema>;

const alarmImportSchema = z.object({
  gatewayId: z.string().nonempty(),
  alarms: z.array(alarmSchema.omit({ gatewayId: true })),
});

type AlarmImportSchemaType = z.infer<typeof alarmImportSchema>;

export { alarmSchema, alarmImportSchema, AlarmRuleOperator };
export type { AlarmSchemaType, AlarmImportSchemaType };
